// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"6f9b19f2","56":"36edb8e8","666":"26e69b91","989":"bcb2f643"}[chunkId] + ".chunk.js";
};